<p-dialog header="Please enter your verification code" [(visible)]="ShowOTP" [style]="{width: '30vw'}" [baseZIndex]="10000"  [modal]="true">
    <div class="field mb-4 col-12" style="text-align: center;">
        <div class="field mb-4 col-12">
            <label for="otp" class="font-medium">To save changes to a statement of risk you will require a verification code, this has been sent to the email registered as the business owner on this account. Please check your email for this code.</label>
            <div class="otp-container" style="display: flex; align-items: center; gap: 10px; margin-top: 10px;">
                <div class="otp-group" style="display: flex; gap: 5px;">
                    <input #otp1 maxlength="1" class="otp-input otp-first" 
                            [(ngModel)]="otpCode[0]" 
                            (input)="onOtpInput($event, 0)" 
                            (keydown)="onOtpKeydown($event, 0)"
                            (paste)="onOtpPaste($event, 0)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; border-radius: 8px 0 0 8px; outline: none;
                                    transition: border-color 0.3s ease;" />
                    <input #otp2 maxlength="1" class="otp-input" 
                            [(ngModel)]="otpCode[1]" 
                            (input)="onOtpInput($event, 1)" 
                            (keydown)="onOtpKeydown($event, 1)"
                            (paste)="onOtpPaste($event, 1)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd;outline: none;
                                    transition: border-color 0.3s ease;" />
                    <input #otp3 maxlength="1" class="otp-input otp-last" 
                            [(ngModel)]="otpCode[2]" 
                            (input)="onOtpInput($event, 2)" 
                            (keydown)="onOtpKeydown($event, 2)"
                            (paste)="onOtpPaste($event, 2)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; border-radius: 0 8px 8px 0; outline: none;
                                    transition: border-color 0.3s ease;" />
                </div>
                <span style="font-size: 24px; font-weight: bold; color: #666; margin: 0 5px;">-</span>
                <div class="otp-group" style="display: flex; gap: 5px;">
                    <input #otp4 maxlength="1" class="otp-input otp-first" 
                            [(ngModel)]="otpCode[3]" 
                            (input)="onOtpInput($event, 3)" 
                            (keydown)="onOtpKeydown($event, 3)"
                            (paste)="onOtpPaste($event, 3)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; border-radius: 8px 0 0 8px; outline: none;
                                    transition: border-color 0.3s ease;" />
                    <input #otp5 maxlength="1" class="otp-input" 
                            [(ngModel)]="otpCode[4]" 
                            (input)="onOtpInput($event, 4)" 
                            (keydown)="onOtpKeydown($event, 4)"
                            (paste)="onOtpPaste($event, 4)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; outline: none;
                                    transition: border-color 0.3s ease;" />
                    <input #otp6 maxlength="1" class="otp-input otp-last" 
                            [(ngModel)]="otpCode[5]" 
                            (input)="onOtpInput($event, 5)" 
                            (keydown)="onOtpKeydown($event, 5)"
                            (paste)="onOtpPaste($event, 5)"
                            style="width: 70px; height: 70px; text-align: center; font-size: 30px; font-weight: bold; 
                                    border: 2px solid #ddd; border-radius: 0 8px 8px 0; outline: none;
                                    transition: border-color 0.3s ease;" />
                </div>
            </div>
        </div>
    </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-lock" label="Submit Code" styleClass="p-button p-button-success" (click)="submitOtpCode()"></p-button>
  </ng-template>
</p-dialog>

<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed && pageReady" class="p-3 flex flex-column flex-auto">
    <div>
        <div class="text-900 font-medium text-xl mb-3"><h3>Statement of Risk
        </h3></div>
        <div class="surface-card p-4 shadow-2 border-round">
            <div class="grid formgrid p-fluid">
                <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Notes</label>
                    <input [(ngModel)]="SOR.name" id="sorname" type="text" [ngStyle]="{'border-color': (sorNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
                </div>
                <div *ngIf="!sorNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Statement of Risk note.</div>

                <!-- <div class="field mb-4 col-12">
                    <label for="sorStartTime" class="font-medium">Start Date</label>
                    <div style="max-width: 500px;">
                        <p-calendar [selectOtherMonths]="true" [(ngModel)]="SOR.startdate" [utc]="true" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" inputId="sorStartTime"></p-calendar>     
                    </div>
                </div> -->

                <!-- <div class="field mb-4 col-12">
                    <label for="sorEndDate" class="font-medium">Start Date</label>
                    <div style="max-width: 500px;">
                        <p-calendar [selectOtherMonths]="true" [(ngModel)]="SOR.enddate" [utc]="true" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" inputId="sorEndDate"></p-calendar>     
                    </div>
                </div> -->
                <div class="field mb-4 col-12">
                    <label for="packageobjdescription" class="font-medium">Statement Of Risk Text</label>
                    <p-editor [(ngModel)]="SOR.text" [style]="{'height':'320px'}">
                        <ng-template pTemplate="header">
                        <span class="ql-formats">
                            <p-header>
                                <span class="ql-formats">
                                    <select class="ql-size">
                                    <option value="small">Small</option>
                                    <option selected value="normal">Normal</option>
                                    <option value="large">Sub Heading</option>
                                    <option value="huge">Heading</option>
                                    </select>

                                    <select class="ql-font">
                                    <option selected value="san serif">San-Serif</option>
                                    <option value="monospace">Monospace</option>
                                    <option value="serif">Serif</option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-bold" aria-label="Bold"></button>
                                    <button class="ql-italic" aria-label="Italic"></button>
                                    <button class="ql-underline" aria-label="Underline"></button>
                                    <button class="ql-strike" aria-label="Strike"></button>
                                    <button class="ql-script" value="sub" title="Subscript"></button>
                                    <button class="ql-script" value="super" title="Superscript"></button>
                                    <button class="ql-indent" value="-1" title="Indent"></button>
                                    <button class="ql-indent" value="+1" title="Outdent"></button>
                                </span>
                                <span class="ql-formats">
                                    <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
                                    </select>
                                    <span class="ql-format-separator"></span>
                                    <select title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-list" title="Ordered" value="ordered"></button>
                                    <button class="ql-list" title="Bullet" value="bullet"></button>

                                    <select title="Text Alignment" class="ql-align" >
                                    <option label="Left"></option>
                                    <option value="center" label="Center"></option>
                                    <option value="right" label="Right"></option>
                                    <option value="justify" label="Justify"></option>
                                    </select>            
                                </span> 
                                <span class="ql-formats">
                                    <button aria-label="Link" class="ql-link"></button>
                                </span>
                                </p-header>
                        </span>
                    </ng-template>
                    </p-editor>
                    <!-- <textarea [(ngModel)]="SOR.text" id="sortext" rows="10" [ngStyle]="{'width':'100%','border-color': (sorTextValid==false) ? '#FF0000':''}"></textarea> -->

                </div>

                <div class="col-12">
                    <button [disabled]="!SOR.isactive" pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    Save Changes</button>
                    &nbsp;
                    <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                    <span class="pi pi-times" style="margin-right:8px;"></span>
                    Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>